import { ja } from './ja';

export const messages = {
  ja
}
